import { EffectiveCart } from 'interfaces/cart';
import sum from 'lodash/sum';

/**
 * Returns the pre-discount item subtotal used in the price summary.
 *
 * When an item has a `compareAtPrice`, that original price is used instead of
 * `defaultPrice` so the subtotal reflects the full non-discounted basket value.
 */
export const getCartSubtotal = (effectiveCart: EffectiveCart): number => {
  const prices = effectiveCart.items.map(
    (item) => (item.compareAtPrice ?? item.defaultPrice) * item.quantity
  );

  return sum(prices);
};
